var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { gql } from '@apollo/client';
import { profile } from '../../profile';
import axios from '../../axios';
export var studentRegistrationQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query getStudentRegistration($code: Int!, $isStudent: Boolean!) {\n    getStudentRegistration(educationPeriod: $code, isStudent: $isStudent) {\n      attendingOrgId\n      attendingOrgName\n      bestLanguageCode\n      grade\n      guardian1EducationLevelCode\n      guardian2EducationLevelCode\n      hispanicOriginCodes\n      raceCodes\n      enrolledRecognizedTribeInd\n      enrolledTribeCd\n      descendantTribe\n      orgStudentId\n      provinceCode\n      countryCode\n      studentId\n      stateCode\n      city\n      resetOrgInd\n    }\n  }\n"])));
export var teacherRegistrationQuery = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query getTeacherRegistration($personId: String, $isProfessional: Boolean!) {\n    getTeacherRegistration(personId: $personId, isProfessional: $isProfessional) {\n      raceCodes\n      hispanicOriginCodes\n      enrolledRecognizedTribeInd\n      enrolledTribeCd\n      descendantTribe\n      educationPeriodCd\n      personId\n    }\n  }\n"])));
export var studentRegistrationMutation = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  mutation saveStudentRegistration(\n    $code: Int!\n    $input: saveStudentRegistration\n    $isStudent: Boolean!\n  ) {\n    saveStudentRegistration(educationPeriod: $code, input: $input, isStudent: $isStudent) {\n      studentId\n    }\n  }\n"])));
export var teacherRegistrationMutation = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  mutation saveTeacherRegistration(\n    $input: saveTeacherRegistration\n    $personId: String\n    $isProfessional: Boolean!\n  ) {\n    saveTeacherRegistration(input: $input, personId: $personId, isProfessional: $isProfessional) {\n      personId\n    }\n  }\n"])));
export var studentPrivacyQuery = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  query getStudentPrivacyRestrictions($orgId: Int!) {\n    getStudentPrivacyRestrictions(orgId: $orgId) {\n      hideRaceField\n      hideEthnicityField\n    }\n  }\n"])));
var tribesQuery = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  query getTribes($getTribes: Boolean!, $isStudent: Boolean!) {\n    getTribes(getTribes: $getTribes, isStudent: $isStudent) {\n      id\n      name\n    }\n  }\n"])));
export var saveStudentRegistration = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(client, variables, values) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            try {
              client.writeQuery({
                query: studentRegistrationQuery,
                variables: variables,
                data: {
                  getStudentRegistration: _objectSpread(_objectSpread({}, values), {}, {
                    __typename: 'studentRegistration'
                  })
                }
              });
            } catch (err) {
              console.info(err);
            }

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function saveStudentRegistration(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var saveTeacherRegistration = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(client, variables, values) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            try {
              client.writeQuery({
                query: teacherRegistrationQuery,
                variables: variables,
                data: {
                  getTeacherRegistration: values
                }
              });
            } catch (err) {
              console.info(err);
            }

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function saveTeacherRegistration(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
export var getSchoolSuggestions = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(suggestion, zip) {
    var _profile, _profile$orgcdsConfig, url, apiKey, zipParam, _yield$axios$request, _yield$axios$request$, total, _yield$axios$request$2, hits, rowCount;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _profile = profile(), _profile$orgcdsConfig = _profile.orgcdsConfig, url = _profile$orgcdsConfig.url, apiKey = _profile$orgcdsConfig.apiKey;
            _context3.prev = 1;
            zipParam = zip ? "&zip=".concat(zip, "&distance=100") : '';
            _context3.next = 5;
            return axios.request({
              method: 'get',
              url: "".concat(url, "/aisearch?name=").concat(suggestion).concat(zipParam, "&size=10&aidomain=ap"),
              withCredentials: false,
              transformRequest: function transformRequest(data, headers) {
                headers.common = {
                  'X-Api-Key': apiKey
                };
                return data;
              }
            });

          case 5:
            _yield$axios$request = _context3.sent;
            _yield$axios$request$ = _yield$axios$request.data.hits;
            total = _yield$axios$request$.total;
            _yield$axios$request$2 = _yield$axios$request$.hits;
            hits = _yield$axios$request$2 === void 0 ? [] : _yield$axios$request$2;
            rowCount = hits.length > 10 ? 10 : hits.length;
            return _context3.abrupt("return", {
              total: total,
              suggestions: hits.slice(0, rowCount).map(function (_ref4) {
                var o = _ref4._source;
                return {
                  orgId: parseInt(o.org_id, 10),
                  orgName: o.org_full_name,
                  city: o.org_city,
                  state: o.org_state_cd,
                  country: o.org_country_iso_cd,
                  address: "".concat(o.org_street_addr1, ", ").concat(o.org_city, ", ").concat(o.org_state_cd || o.org_country_iso_cd, " ").concat(o.org_zip5 || '')
                };
              })
            });

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", {
              suggestions: [],
              total: 0
            });

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 14]]);
  }));

  return function getSchoolSuggestions(_x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();
export var getTribes = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref5) {
    var client, isStudent, _yield$client$query, _yield$client$query$d, data;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            client = _ref5.client, isStudent = _ref5.isStudent;
            _context4.prev = 1;
            _context4.next = 4;
            return client.query({
              query: tribesQuery,
              variables: {
                getTribes: true,
                isStudent: isStudent
              }
            });

          case 4:
            _yield$client$query = _context4.sent;
            _yield$client$query$d = _yield$client$query.data;
            data = _yield$client$query$d === void 0 ? {} : _yield$client$query$d;
            return _context4.abrupt("return", data.getTribes || []);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](1);
            console.info(_context4.t0);

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 10]]);
  }));

  return function getTribes(_x9) {
    return _ref6.apply(this, arguments);
  };
}();